import { clsx } from 'clsx';
import { HtmlHTMLAttributes } from 'react';

import './TextQuaternary.css';

export type TextQuaternaryProps = HtmlHTMLAttributes<HTMLSpanElement>;

export const TextQuaternary = ({ className, ...textProps }: TextQuaternaryProps) => {
  return <span className={clsx('text-quaternary', className)} {...textProps} />;
};
